module.exports = __webpack_public_path__ + "images/169_1024.jpg";